import { urlProductList } from '@/urls';
import { useCurrentClub } from '@/hooks/use-current-club';
import { useAsync } from '@repo/ui/hooks/use-async';
import { useForm } from '@repo/ui/hooks/use-form';
import { productApi } from '@repo/api-client';
import { Input } from '@repo/ui/components/form/input';
import { Button } from '@repo/ui/components/button';
import { Select } from '@repo/ui/components/form/select';
import { ProductCategory } from '@repo/shared-types';
import { useNavigate, useRevalidator } from 'react-router';
import { GeneralError } from '@repo/ui/components/form/general-error';

interface CreateProductFormProps {
  categories: ProductCategory[];
}

export function CreateProductForm({ categories }: CreateProductFormProps) {
  const club = useCurrentClub();
  const navigate = useNavigate();
  const revalidator = useRevalidator();

  const { execute: onSubmit, error: apiErrors } = useAsync(async () => {
    await productApi.createProduct(club.id, values);
    navigate(urlProductList(club.id), { viewTransition: true });
    // wait 100ms
    await new Promise((resolve) => setTimeout(resolve, 100));
    revalidator.revalidate();
  });

  const {
    ref,
    values,
    errors: formErrors,
  } = useForm({
    initialValues: {
      name: '',
      sku: '',
      price: 0,
      categoryId: '',
    },
    onSubmit,
  });

  const errors = { ...formErrors, ...apiErrors };

  return (
    <form ref={ref} className="w-full flex flex-col gap-4">
      <Input label="SKU" type="text" name="sku" required errors={errors} />
      <Input label="Nombre" type="text" name="name" required errors={errors} />
      <Select
        label="Categoría"
        name="categoryId"
        options={[
          { label: 'Sin categoría', value: '' },
          ...categories.map((category) => ({
            label: category.name,
            value: category.id,
          })),
        ]}
      />
      <GeneralError errors={errors} />
      <Button type="submit">Crear</Button>
    </form>
  );
}
